import { Button, Col, Form, Input,  message,  Row } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { useYonghuUpdateCodeMutation, useYonghuUpdateMiMaMutation } from '../store/DianShangYeWuApi';
import { useNavigate } from 'react-router-dom';
import classes from './web.module.css';
import WebFoot from './WebFoot';
function WebPassword() {
    //获取已登录用户数据
    const prevUserPhone = JSON.parse(localStorage.getItem('eu_ba_phone'));
    //绑定手机号
    const [adminPhone, setAdminPhone] = useState(prevUserPhone);
    const adminPhoneInput = (e) => {
        setAdminPhone(prevState => e.target.value);
    }
    //新密码
    const [info, setInfo] = useState({
        yh_mima: '',
    });
    //绑定验证码
    const [adminCode, setAdminCode] = useState();
    const adminCodeInput = (e) => {
        setAdminCode(prevState => e.target.value);
    }
    //验证码倒计时
    const [isNote, setIsNote] = useState(false);
    const [time, setTime] = useState(null);
    const timeRef = useRef();
    useEffect(() => {
        if (time && time !== 0) {
            timeRef.current = setTimeout(() => {
                setTime((time) => time - 1);
            }, 1000);
        } else {
            setIsNote(false);
        }
        return () => {
            clearInterval(timeRef.current);
        };
    }, [time]);
  
    //获取验证码数据
    const [getCode] = useYonghuUpdateCodeMutation();
    //获取验证码
    const getCodeBtn = () => {
        setTime(60);
        setIsNote(true);
        getCode({
            phone:adminPhone,
        }).then((res) => {
            // console.log(res);
            if(res.data.Status==='success'){
                setTime(60);
                setIsNote(true);
            }
            if (res.data.Status === 'fail') {
                message.error('该手机号码未注册！'+ res.data.Message)    
            }
        })    
    }
    //数据上传
    const [resetPassword] = useYonghuUpdateMiMaMutation();    
   
    //跳转
    const navi = useNavigate();
    //短信验证码登录，保存表单
    const onFinish = (values) => {
        resetPassword({
            yh_qy_name:JSON.parse(localStorage.getItem('jtg-caiwu_qy_name')),
            yh_phone:adminPhone,
            yh_mima:info.yh_mima,
            phone_code:adminCode,
        }).then(res => {
            // console.log(res);     
            if (res.data.Status === "success") {                  
                message.success('密码重置成功！');                
                navi('/WebLogin');

            } else if (res.data.Status === 'fail') {
                message.error(res.data.Message);             
            }
        })        
    };
    //保存表单（失败）  
    const onFinishFailed = (errorInfo) => {
        // console.log('Failed:', errorInfo);
    };
    return (
        <>
            <div className={classes.loginBack}>
                <div style={{fontSize:"30px",fontWeight:"bold"}}>费用报销</div>
                <div>重置密码</div>   
                <div className={classes.loginForm}>                       
                    <Form
                        name="normal_login"
                        className="login-form"
                        initialValues={{remember: true,}}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}   
                        labelCol={{span:6}}
                    >
                        <Form.Item
                            label="企业名称"
                            name="yh_qy_name"
                            required
                        >
                            <Input 
                                onChange={(e) => setInfo({...info,yh_qy_name: e.target.value})} 
                            />
                        </Form.Item>
                        <Form.Item
                            name="username"
                            validateTrigger="onBlur"
                            rules={[{
                                required: true,
                                message: '请填写手机号!',
                            },
                            {
                            pattern: /^1[3-9]\d{9}$/,
                            message: '请输入正确的手机号'
                                }]}
                            initialValue={prevUserPhone}             
                            label="手机号"                                            
                        >
                            <Input 
                                placeholder="请输入手机号" 
                                value={adminPhone} 
                                onChange={adminPhoneInput} 
                            />
                        </Form.Item>
                        <Form.Item label='短信验证码' required>
                            <Row gutter={5}>
                                <Col span={14}>
                                    <Form.Item
                                        name="captcha"
                                        validateTrigger="onBlur"    
                                        noStyle
                                        rules={[
                                                {
                                                    required: true,
                                                    message: '请输入短信验证码!',
                                                },
                                                {
                                                    pattern: new RegExp('^\\d{6}$'),
                                                    message: '请输入正确的6位数字验证码!',
                                                },
                                            ]}
                                        >
                                            <Input 
                                                size="large" 
                                                placeholder='请输入短信验证码' 
                                                value={adminCode} 
                                                onChange={adminCodeInput} 
                                            />
                                    </Form.Item>
                                </Col>
                                <Col span={10}>
                                    {isNote ? <Button disabled size="large" >{time}秒后重新发送</Button> : <Button size="large"  onClick={getCodeBtn}>获取验证码</Button>}
                                </Col>
                            </Row>
                        </Form.Item> 
                        <Form.Item
                            label='新密码'
                            name="newPassword"
                            validateTrigger="onBlur"
                            rules={[{
                                required: true,
                                message: '请填写新密码!',
                            },
                        ]}
                            wrapperCol={{span:13}}
                        >
                            <Input 
                                placeholder="请输入新密码" 
                                onChange={(e) => {setInfo(prevState=>({...prevState,yh_mima:e.target.value}))}}   
                                type='password'                          
                            />
                        </Form.Item>                                
                        <Form.Item wrapperCol={{offset:"6"}}>
                            <Button type='primary' htmlType="submit"  size="large">提交</Button>                                
                        </Form.Item>
                        
                        {/* <div className={classes.loginTips}>
                            <a onClick={() => {setOpenAdd(true)}}>还没有注册？请使用手机注册</a>
                            <a onClick={() => {navi('/')}}>返回新增台账</a>
                        </div> */}
                    </Form>
                </div>
            </div>
            <WebFoot/>
        </>
    )
}

export default WebPassword